import { FaBoxOpen, FaCreditCard, FaGlobe, FaMoneyBillWave, FaTimesCircle, FaUtensils } from "react-icons/fa";
import {
  ORDER_NEXT_ACTION,
  canCancelOrder,
  getOrderStatusMeta,
} from "../services/orderStatusModel";

import { formatPersianNumber as persianNumber } from "../utils/persianNumber";

const paymentConfig = {
  cash: { label: "نقدی", icon: <FaMoneyBillWave /> },
  online: { label: "آنلاین", icon: <FaGlobe /> },
  card: { label: "کارتخوان", icon: <FaCreditCard /> },
};

export default function OrderList({ orders, onStatusChange }) {
  if (!orders.length) {
    return (
      <div className="rounded-2xl border border-dashed border-gray-200 bg-white px-4 py-14 text-center">
        <FaUtensils className="mx-auto text-3xl text-gray-300" aria-hidden="true" />
        <p className="mt-3 font-bold text-gray-800">سفارشی یافت نشد</p>
        <p className="mt-1 text-sm text-gray-500">فیلتر یا جست‌وجو را تغییر دهید.</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-3">
      {orders.map((order) => {
        const orderDate = new Date(order.createdAt);
        const status = getOrderStatusMeta(order.status);
        const nextAction = ORDER_NEXT_ACTION[order.status];
        const payment = paymentConfig[order.paymentType] || { label: order.paymentType || "نامشخص", icon: "❔" };

        return (
          <article key={order._id} className="flex flex-col rounded-2xl border border-gray-100 bg-white p-4 shadow-sm">
            <div className="flex items-start justify-between gap-2">
              <div>
                <p className="font-bold text-gray-900">
                  {order.tableNumber ? `میز ${persianNumber(order.tableNumber)}` : "بیرون‌بر"}
                </p>
                <p className="mt-0.5 text-xs text-gray-400">
                  سفارش {persianNumber(order.orderNumber)} · {orderDate.toLocaleDateString("fa-IR")} {orderDate.toLocaleTimeString("fa-IR", { hour: "2-digit", minute: "2-digit" })}
                </p>
              </div>
              <span className={`shrink-0 rounded-full px-3 py-1 text-xs font-bold ${status.badgeClass}`}>{status.label}</span>
            </div>

            <div className="mt-3 divide-y divide-gray-100 text-sm">
              {order.items.map((item) => (
                <div key={item._id} className="flex items-center justify-between py-2">
                  <span className="text-gray-700">
                    {item.name} <span className="text-gray-400">× {persianNumber(item.quantity)}</span>
                  </span>
                  <span className="font-medium text-gray-600">{item.total.toLocaleString("fa-IR")} تومان</span>
                </div>
              ))}
            </div>

            <div className="mt-3 flex items-center gap-4 text-xs text-gray-500">
              <span className="flex items-center gap-1">
                <span className="text-secondary">{payment.icon}</span>
                {payment.label}
              </span>
              <span className="flex items-center gap-1">
                <FaBoxOpen className="text-secondary" aria-hidden="true" />
                {persianNumber(order.items.length)} آیتم
              </span>
            </div>

            <div className="mt-4 flex items-center justify-between border-t border-gray-100 pt-3">
              <span className="font-black text-accent">{order.totalPrice.toLocaleString("fa-IR")} تومان</span>
              <div className="flex gap-2">
                {canCancelOrder(order.status) && (
                  <button
                    type="button"
                    onClick={() => onStatusChange(order._id, "canceled")}
                    className="flex items-center gap-1 rounded-lg px-3 py-2 text-xs font-bold text-red-500 transition-colors hover:bg-red-50"
                  >
                    <FaTimesCircle aria-hidden="true" />
                    لغو سفارش
                  </button>
                )}
                {nextAction && (
                  <button
                    type="button"
                    onClick={() => onStatusChange(order._id, nextAction.status)}
                    className="rounded-lg bg-accent px-3 py-2 text-xs font-bold text-white transition-opacity hover:opacity-90"
                  >
                    {nextAction.label}
                  </button>
                )}
              </div>
            </div>
          </article>
        );
      })}
    </div>
  );
}
